import CustomIcon from "../../../../components/CustomIcon";
import ToggleSwitch from "../../../../components/toggleSwitch/ToggleSwitch";
import {enableDisableProvince, renameProvince} from "../../../../redux/slices/locationSlice";
import CustomButton, {DangerButton} from "../../../../components/CustomButton";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Input from "../../../../components/form/Input";
import CustomModal from "../../../../components/CustomModal";
import EmptyState from "../../../../components/EmptyState";

const ProvinceDetail = ({setIsAddingCities}) => {
  const {
    province,
    city,
    currentProvince,
    processing
  } = useSelector((state => state.location))
  const dispatch = useDispatch();

  useEffect(() => {
    setIsAddingCities(false)
  }, [city])

  return (
    <>
      <div className="px-4 py-4 bg-white shadow rounded-xl space-y-2">
        <div className="flex justify-between">
          <h1>Province</h1>
        </div>
        <div className="flex justify-between">
          {province.loading  ?
            <div className="w-48 h-6 bg-secondary-100"/>
            :
            <label className="font-bold">{currentProvince?.name}</label>}

          <ToggleSwitch isChecked={!currentProvince?.disabled ?? false}
                        isDisabled={province.loading}
                        onChange={() => {
                          //TODO setCurrentProvince({...currentProvince, disabled: !currentProvince?.disabled})
                          dispatch(enableDisableProvince({
                            provinceId: currentProvince?.id,
                            value: !currentProvince?.disabled
                          }))

                          // dispatch(setCurrentProvince())

                        }}/>

        </div>
        <div className="flex py-5 space-x-5">
          <div>Allow for campaign</div>
          <ToggleSwitch isChecked={currentProvince?.campaign_location ?? false}
                        isDisabled={province.loading}
                        onChange={() => {
                          dispatch(enableDisableProvince({
                            provinceId: currentProvince?.id,
                            value: !currentProvince?.campaign_location,
                            isCampaign: true
                          }))
                        }}/>
        </div>

        <CustomButton disabled={province.loading} onClick={() => setIsAddingCities(true)}>
          Add Cities
        </CustomButton>
      </div>
    </>
  )
}


const ProvinceItemLoader = (loading, error, isEmpty, retry) => {
  return (
    (error.length > 0) ?
      <div>
        <div>Error Loading Data</div>
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>
      : (isEmpty && !loading) ?
        <EmptyState message={"No records to display."}/>
        :
        <div className="w-48 h-6 bg-secondary-100"/>
  )
}

export default ProvinceDetail;
